export const PREVIEW_ERROR_KEY = 'previewError';

export const errorsMap = new Map([
  ['playPromise reject - stream unavaible', 'Видеопоток недоступен'],
  ['play_promise_reject', 'Не удалось загрузить видеопоток'],
  ['Media error', 'Не удалось загрузить видеопоток'],
  [undefined, 'Не удалось загрузить видеопоток'],
  ['WebSocket lost connection', 'Нет связи с камерой'],
  [PREVIEW_ERROR_KEY, 'Не удалось загрузить превью'],
]);

export const UNEXPECTED_ERROR = 'Непредвиденная ошибка';
export const VIDEO_PLAYBACK_ERROR = 'Ошибка при воспроизведении';

export const dropdownActionsData = {
  bigScreen: {
    key: 'bigScreen',
    text: 'Вывести на большой экран',
  },
};

export const cameraParentViews = {
  table: 'table',
  grid: 'grid',
};

export const controlPanelPositions = {
  bottom: 'bottom',
  top: 'top',
};

export const controlPanelSizes = {
  small: 'small',
  medium: 'medium',
  large: 'large',
};

export const controlBtnSizes = {
  extraSmall: 'extraSmall',
  small: 'small',
  medium: 'medium',
  large: 'large',
};
